module.exports = __webpack_public_path__ + "img/pdf.5b4cea8d.png";